const AfiliadoIndicacaoOrigem = {
  INDIQUE_GANHE: 1,
  INDIQUE_GANHE_EGRESSO: 2,
};

export default AfiliadoIndicacaoOrigem;
